// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

import CustomNavbarv2 from './ui/navbar2';
import HeaderContent from './ui/headerContent';

const HeaderContainer = styled.header`
  height: 60vh;
  z-index: 2;
`;

const Header = () => {
  return (
    <HeaderContainer>
      <CustomNavbarv2/>
      <HeaderContent/>
    </HeaderContainer>
  );
};

export default Header;
